/* eslint-disable class-methods-use-this */

export default class Accessibility {
  constructor() {
    this.accessibleSelect();
  }

  /**
   * Adds focus states to custom select wrapper
   * @return {Void}
   */
  accessibleSelect() {
    // Get all select elements
    const selectNodes: any = document.getElementsByTagName('select');

    // Transform node list to array
    const selects: HTMLSelectElement[] = Array.prototype.slice.call(selectNodes);

    selects.forEach((select) => {
      select.addEventListener('focus', (e: any) => {
        e.currentTarget.parentNode.classList.add('is-focussed');
      });

      select.addEventListener('focusout', (e: any) => {
        e.currentTarget.parentNode.classList.remove('is-focussed');
      });

      if (select.hasAttribute('disabled')) {
        const parent: any = select.parentNode;
        parent.classList.add('is-disabled');
      }
    });
  }
}
